import { useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const ImageCarousel = ({ images, aspect = "aspect-[720/535]" }) => {
  const [i, setI] = useState(0);
  const touch = useRef(null);
  const go = (d) => setI((v) => (v + d + images.length) % images.length);
  const btn = "absolute top-1/2 -translate-y-1/2 grid place-items-center h-11 w-11 rounded-full bg-ink-deep/55 text-white backdrop-blur-md border border-white/15 hover:bg-ink-deep/80 transition-colors";
  return (
    <div
      data-testid="concept-carousel"
      className={`relative ${aspect} overflow-hidden bg-ink-deep`}
      onTouchStart={(e) => { touch.current = e.touches[0].clientX; }}
      onTouchEnd={(e) => { const dx = e.changedTouches[0].clientX - touch.current; if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); }}
    >
      <AnimatePresence initial={false}>
        <motion.img
          key={i}
          data-testid="concept-rendering"
          src={images[i].src}
          alt={images[i].alt}
          initial={{ opacity: 0, scale: 1.03 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </AnimatePresence>
      <button data-testid="concept-carousel-prev" aria-label="Previous image" onClick={() => go(-1)} className={`${btn} left-4`}><ChevronLeft size={20} /></button>
      <button data-testid="concept-carousel-next" aria-label="Next image" onClick={() => go(1)} className={`${btn} right-4`}><ChevronRight size={20} /></button>
      <div className="absolute bottom-0 inset-x-0 flex items-center justify-between px-5 py-4 bg-gradient-to-t from-ink-deep/70 to-transparent">
        <span data-testid="concept-carousel-caption" className="text-xs sm:text-sm text-white/90 min-w-0 truncate mr-3">{images[i].alt}</span>
        <div className="flex items-center gap-3 shrink-0">
          <div className="flex gap-1.5">
            {images.map((im, k) => (
              <button key={im.src} data-testid={`concept-carousel-dot-${k}`} aria-label={`Image ${k + 1}`} onClick={() => setI(k)}
                className={`h-1.5 rounded-full transition-[width,background-color] duration-300 ${k === i ? "w-6 bg-white" : "w-1.5 bg-white/50 hover:bg-white/80"}`} />
            ))}
          </div>
          <span data-testid="concept-carousel-counter" className="font-mono text-[11px] text-white/70 whitespace-nowrap">{String(i + 1).padStart(2, "0")} / {String(images.length).padStart(2, "0")}</span>
        </div>
      </div>
    </div>
  );
};
